import { render, staticRenderFns } from "./SettingsEmail.vue?vue&type=template&id=c784aebc&scoped=true&"
import script from "./SettingsEmail.vue?vue&type=script&lang=js&"
export * from "./SettingsEmail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEmail.vue?vue&type=style&index=0&id=c784aebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c784aebc",
  null
  
)

export default component.exports